import { Button, ButtonText } from '@/ui/core/button'
import { SKIP_LABEL } from '../logic/stepState'

interface PrimaryStepButtonProps {
	label: string
	onPress: () => void
	disabled?: boolean
	isLoading?: boolean
}

/**
 * The one button at the foot of a step.
 *
 * Black is for going on with an answer. A step offering to be skipped is outlined instead: on an
 * optional step with nothing entered, the loudest thing on the screen should not be the way out
 * of it.
 */
export const PrimaryStepButton = ({
	label,
	onPress,
	disabled = false,
	isLoading = false,
}: PrimaryStepButtonProps) => (
	<Button
		fullWidth
		variant={label === SKIP_LABEL ? 'secondary' : 'primary'}
		onPress={onPress}
		disabled={disabled || isLoading}
		isLoading={isLoading}
	>
		<ButtonText>{label}</ButtonText>
	</Button>
)
